// extracted by mini-css-extract-plugin
export default {"listCards":"Portfolios_listCards__M7v5U"};